module.exports = __webpack_public_path__ + "img/help-image-fr.f966bbf5.png";